var map = {
	"./Doctor-consultation-icon.png": 7631,
	"./Doctor-consultation-icon.svg": 327,
	"./Emergency-Icon.png": 7973,
	"./Emergency-Icon.svg": 2177,
	"./Male-doctor-logo.svg": 9125,
	"./O2-icon.png": 7059,
	"./ambulance.svg": 2816,
	"./circle_ambulance.png": 2673,
	"./circle_doctor.png": 7638,
	"./circle_homecare.png": 1349,
	"./circle_hospital.png": 5821,
	"./circle_hospital.svg": 9507,
	"./circle_medical_tourism.png": 7604,
	"./circle_pathology.png": 4708,
	"./diagonostics-consultation-icon.png": 69,
	"./diagonostics-consultation-icon.svg": 3057,
	"./facebook-logo.png": 3816,
	"./female-doctor-logo.svg": 5486,
	"./firstAid-icon.png": 7266,
	"./graphics-banner-image.png": 5862,
	"./graphics-banner-mob-image.png": 8747,
	"./hospital-admission-icon.png": 80,
	"./hospital-admission-icon.svg": 578,
	"./insta-logo.png": 261,
	"./medicine-consultation-icon.png": 7226,
	"./medicine-consultation-icon.svg": 922,
	"./portable-suction.png": 945,
	"./portable-suction.svg": 1025,
	"./red-line-animated.svg": 2124,
	"./strature-icon.png": 286,
	"./surgery-consultation-icon.png": 5493,
	"./surgery-consultation-icon.svg": 7119,
	"./wheel-chair-icon.png": 7275,
	"./xmark-solid.svg": 3783
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4680;